import React from 'react';
import styled from 'styled-components';

export const TRUNCATE_AT = 80;

const Notes = styled.span`
  white-space: pre-wrap;
  /* Wrap long text but never split inside a word (TUL-5517). */
  overflow-wrap: break-word;
`;

const Empty = styled.span`
  color: #9aa0a6;
`;

const buildTitle = ({ resolutionNotes, status, resolvedAt }) => {
  const meta = [
    status,
    resolvedAt ? new Date(resolvedAt).toLocaleString() : null,
  ].filter(Boolean).join(', ');
  return meta ? `${resolutionNotes}\n\n(${meta})` : resolutionNotes;
};

const DeviationResolutionCell = ({ value }) => {
  if (!value) {
    return <Empty data-testid="deviation-resolution-empty">—</Empty>;
  }
  if (!value.resolutionNotes) {
    return (
      <Empty
        data-testid="deviation-resolution-empty"
        data-status={value.status || undefined}
        title={value.status || undefined}
      >
        —
      </Empty>
    );
  }
  const { resolutionNotes, status } = value;
  const truncated = resolutionNotes.length > TRUNCATE_AT
    ? `${resolutionNotes.slice(0, TRUNCATE_AT).trimEnd()}…`
    : resolutionNotes;
  return (
    <Notes title={buildTitle(value)} data-status={status || undefined}>
      {truncated}
    </Notes>
  );
};

export default DeviationResolutionCell;
